import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pantry-category-title-view" }
const _hoisted_2 = { class: "pantry-category-title-view-title" }
const _hoisted_3 = { class: "pantry-category-title-view-title-text" }
const _hoisted_4 = { class: "pantry-category-title-view-button-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    (_ctx.isShowLabel())
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "pantry-category-title-view-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickButton(...args)))
        }, [
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.buttonLabel), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}